/* eslint-disable */
'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _draftJs = require('draft-js');

var _draftJsExportHtml = require('draft-js-export-html');

require('./draft.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DraftRenderer = function (_PureComponent) {
  _inherits(DraftRenderer, _PureComponent);

  function DraftRenderer() {
    _classCallCheck(this, DraftRenderer);

    return _possibleConstructorReturn(this, (DraftRenderer.__proto__ || Object.getPrototypeOf(DraftRenderer)).apply(this, arguments));
  }

  _createClass(DraftRenderer, [{
    key: 'render',
    value: function render() {
      if (!this.props.content) {
        return null;
      }

      var rawState = void 0;

      try {
        rawState = JSON.parse(this.props.content);
      } catch (e) {
        return null;
      }

      if (!rawState) {
        return null;
      }

      var contentState = (0, _draftJs.convertFromRaw)(rawState);

      var options = this.props.makeOptions(contentState);

      var contentHtml = (0, _draftJsExportHtml.stateToHTML)(contentState, options);

      if (this.props.postProcessor) {
        contentHtml = this.props.postProcessor(contentHtml);
      }

      return _react2.default.createElement('div', {
        className: 'draft-js-content',
        dangerouslySetInnerHTML: { __html: contentHtml }
      });
    }
  }]);

  return DraftRenderer;
}(_react.PureComponent);

exports.default = DraftRenderer;


DraftRenderer.propTypes = {
  content: _propTypes2.default.string
};


// WEBPACK FOOTER //
// ./src/utils/editor/lib/components/DraftRenderer.js